module.exports = __webpack_public_path__ + "img/server01.80ee5a18.jpg";